import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import * as api from '../api';

export const fetchAccount = makeAsyncAction(
  types.FETCH_ACCOUNT,
  (emailOrId) => () => api.getAccount(emailOrId)
);

export const enableDeveloperAccess = makeAsyncAction(
  types.ENABLE_DEVELOPER_ACCESS,
  (accountId) => () => api.enableDeveloperAccess(accountId),
);

export const updateAccount = makeAsyncAction(
  types.UPDATE_ACCOUNT,
  (details) => () => api.updateAccount(details),
  'ok'
);
